import { PAGE_TYPE, type PageType } from '../../Constants/PageType';

export const getPageTypeFromPathname = (pathname: string): PageType | '' => {
  if (pathname.includes('/auto/')) return PAGE_TYPE.Pdp;
  if (pathname.includes('/cars/lease-deals')) return PAGE_TYPE.LeasingPlp;
  if (pathname.includes('/cars/used') || pathname.includes('/cars/new')) return PAGE_TYPE.Plp;
  if (pathname.includes('/cars/') && pathname.includes('/reviews')) return PAGE_TYPE.Review;
  if (pathname.includes('/car-compare')) return PAGE_TYPE.CarCompare;
  if (pathname.includes('/electric-cars')) return PAGE_TYPE.ElectricCars;
  if (pathname.includes('/guides')) return PAGE_TYPE.Guides;
  if (pathname.includes('/favourites')) return PAGE_TYPE.Favourites;
  if (pathname.includes('/leasing')) return PAGE_TYPE.Leasing;
  if (pathname === '/' || /^\/(de|es)\/?$/.test(pathname)) return PAGE_TYPE.Home;

  return PAGE_TYPE.UniversalPage;
};
